import { render, staticRenderFns } from "./seltos-usp-swiper.vue?vue&type=template&id=420490a7&scoped=true"
import script from "./seltos-usp-swiper.vue?vue&type=script&lang=js"
export * from "./seltos-usp-swiper.vue?vue&type=script&lang=js"
import style0 from "./seltos-usp-swiper.vue?vue&type=style&index=0&id=420490a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420490a7",
  null
  
)

export default component.exports